export type Hardware =
  | {
    HardwareRegisterID: number;
    HardwareTypeID: HardwareType.KIT_DRIVE | HardwareType.SWAT_DRIVE;
    AssetTag: string;
    SerialNumber: string;
    OtherDetails: DriveDetails;
    CCDatabaseID: number;
    CCSentDateSec: number;
    CCReceivedDateSec: number;
    ReceivedDateSec: number;
    ReceivedByID: number;
    ReturnedDateSec: number;
    ReturnedByID: number;
    DeletedDateSec: number;
    DeletedByID: number;
  }
  | {
    HardwareRegisterID: number;
    HardwareTypeID: HardwareType.SCANNER;
    AssetTag: string;
    SerialNumber: string;
    OtherDetails: ScannerDetails;
    CCDatabaseID: number;
    CCSentDateSec: number;
    CCReceivedDateSec: number;
    ReceivedDateSec: number;
    ReceivedByID: number;
    ReturnedDateSec: number;
    ReturnedByID: number;
    DeletedDateSec: number;
    DeletedByID: number;
  };


export type DriveDetails = {
  driveName: string;
  dispatchReference: string;
  model: string;
};
export type ScannerDetails = {
  model: 'TS1' | 'TS1-B';
  dispatchReference: string;
};

export enum HardwareType {
  SCANNER = 1,
  KIT_DRIVE = 2,
  SWAT_DRIVE = 3,
}